var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagingForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85602 20V15C1.85602 13.1318 2.32194 11.8876 3.10505 11.1045C3.88815 10.3214 5.13235 9.85547 7.00055 9.85547H20.9361L16.3961 14.3955L16.3375 14.46C16.0633 14.7958 16.0829 15.2914 16.3961 15.6045C16.7092 15.9176 17.2048 15.9373 17.5406 15.6631L17.605 15.6045L23.605 9.60449C23.9389 9.27059 23.9389 8.72941 23.605 8.39551L17.605 2.39551C17.2711 2.06161 16.73 2.06161 16.3961 2.39551C16.0622 2.72941 16.0622 3.27059 16.3961 3.60449L20.9361 8.14453H7.00055C4.86876 8.14453 3.11296 8.67861 1.89606 9.89551C0.679165 11.1124 0.145084 12.8682 0.145084 15V20C0.145084 20.4722 0.528349 20.8555 1.00055 20.8555C1.47276 20.8555 1.85602 20.4722 1.85602 20Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingForward);
export default __webpack_public_path__ + "static/media/messaging-forward.7fe2d0083e6454a088a60459a655ba55.svg";
export { ForwardRef as ReactComponent };